/*
    eslint has been removed from this folder's gulpfile,
    as the volume of errors after merging in north studio's work
    was causing memory limits to be exceeded and the task
    was failing silently
*/
"use strict";
// wait for the DOM to load
document.addEventListener("DOMContentLoaded", function () {
    // polyfill to enable us to use forEach on node lists in IE11
    const ForEachPolyfill = require("./modules/foreach-polyfill");
    ForEachPolyfill.init();
    // toggle visibility of lane on interaction with that lane's category button
    const LaneToggle = require("./modules/lane-toggle");
    LaneToggle.init();
    // toggle display of definition list, and relevant definition list item,
    // on interaction with a sub-lane toggle button
    const DefinitionListItemToggle = require("./modules/definition-list-toggle");
    DefinitionListItemToggle.init();
    // toggle display of phase information list, and relevant phase information item,
    // on interaction with a phase information toggle button
    const PhaseInformationToggle = require("./modules/phase-information-list-toggle");
    PhaseInformationToggle.init();
    // close a visible definition list on interaction with it's close button,
    // and hide all of the definition list's items
    const DefinitionListItemClose = require("./modules/definition-list-close");
    DefinitionListItemClose.init();
    // creates tooltip for given list of abbreviations
    const Tooltip = require("./modules/tooltip");
    Tooltip.init();
    const Tutorial = require("./modules/tutorial");
    Tutorial.init();
    // expand/close all buttons at top of document
    const AllLanesToggle = require("./modules/all-lanes-toggle");
    AllLanesToggle.init();
    // fix phases key to top of viewport on scroll
    const PhasesKeyFixed = require("./modules/phases-key-viewport-fixed");
    PhasesKeyFixed.init();
    // hide specific bullet points in tables
    // (any CSS hack for this resulted in browser compatability issues)
    const HideNotBullet = require("./modules/hide-not-bullet");
    HideNotBullet.init();
});
